import { map } from 'lodash';
const actions = {
    /**
     * @description Save the reminders for kids vaccines
     * @param commit
     * @param rootGetters
     * @param payload
     * @returns {Promise}
     */
    sendReminders({ commit, rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        return this._vm.$api.other.sendReminders(establishmentId, payload);
    },

    /**
     * @description Confirm an appointment with the token
     * @param commit
     * @param payload
     * @returns {Promise}
     */
    confirmAppointment({ commit }, payload) {
        return this._vm.$api.other.confirmAppointment(payload);
    },

    /**
     * @description Cancel an appointment with the ticket number
     * @param commit
     * @param payload
     * @returns {Promise}
     */
    cancelAppointment({ commit }, payload) {
        return this._vm.$api.other.cancelAppointment(payload);
    },

    /**
     * @description Send an email to an establishment by the Join Us page
     * @param commit
     * @param payload
     * @returns {Promise}
     */
    sendJoinUsMail({ commit }, payload) {
        return this._vm.$api.other.sendJoinUsMail(payload);
    },

    /**
     * @description Fetch the Api to retriveve a lost coupon by mail
     * @param commit
     * @param payload
     * @returns {Promise}
     */
    async sendCouponLostMail({ commit, rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        return this._vm.$api.other.sendCouponLostMail(establishmentId, payload);
    },

    async geocode({ commit }, payload) {
        let addressComponents = {
            isAddressNotFound: true,
            address: null,
            latitude: null,
            longitude: null,
        };

        const response = await this._vm.$api.other.geocode(payload);
        const data = response.data;
        const address = map(data.results, 'formatted_address');

        if(address.length === 1) {
            const geometry = map(data.results, 'geometry');
            addressComponents = {
                isAddressNotFound: false,
                address: address[0],
                latitude: geometry[0].location.lat,
                longitude: geometry[0].location.lng,
            };
        }
        return addressComponents;
    },

    async geocoder({ commit }, payload) {
        const response = await this._vm.$api.other.geocoder(payload);
        return response.data;
    },
};

export default {
    namespaced: true,
    actions,
};
